import { type CountdownState, formatCountdownHoursMinutes } from './countdown';

interface VisitLuckyTicketTileSource {
  isReceivable: boolean;
  isDailyCapReached: boolean;
  countdown: CountdownState;
}

interface VisitLuckyTicketTile {
  isBadgeActive: boolean;
  cooldownLabel: string | null;
}

//* 일일 상한은 회원 단위라 몰별 쿨다운 칩과 섞지 않는다 — 섞으면 30분 남은 몰이 「내일」로 보인다.
export const resolveVisitLuckyTicketTile = ({
  isReceivable,
  isDailyCapReached,
  countdown,
}: VisitLuckyTicketTileSource): VisitLuckyTicketTile => {
  if (isDailyCapReached) {
    return { isBadgeActive: false, cooldownLabel: null };
  }

  if (isReceivable || countdown.isAvailable) {
    return { isBadgeActive: isReceivable, cooldownLabel: null };
  }

  return {
    isBadgeActive: false,
    cooldownLabel: formatCountdownHoursMinutes(countdown.secondsUntilAvailable),
  };
};

export const resolveVisitLuckyTicketGrantMessage = (
  visitLuckyTicket: { grantedCount?: number } | null | undefined,
) => {
  const grantedCount = visitLuckyTicket?.grantedCount ?? 0;

  return grantedCount > 0 ? `행운권 ${grantedCount}장을 받았어요` : null;
};
